const subjectsForTopic = (topic, config) => {
  try {
    return config.topics.find((element) => element.name === topic).subjects;
  } catch (e) {
    return null;
  }
};

const selectedSubject = (topic, subject, config) => {
  try {
    return subjectsForTopic(topic, config).find((element) => element.name === subject);
  } catch (e) {
    return null;
  }
};

const topicExists = (topic, config) => {
  try {
    return config.topics.some((element) => element.name === topic);
  } catch (e) {
    return false;
  }
};

const relocateTo = (topic, subject, config) => {
  if (selectedSubject(topic, subject, config)) return { topic, subject };
  if (topicExists(topic, config)) return { topic, subject: '' };
  return {};
};

const clearErrors = (fields) =>
  Object.keys(fields).reduce((errors, key) => {
    const newErrors = errors;
    newErrors[key] = '';
    return newErrors;
  }, {});

const validationErrorsPresent = (errors) => !Object.values(errors).every((value) => value === '');

export {
  subjectsForTopic,
  selectedSubject,
  topicExists,
  relocateTo,
  clearErrors,
  validationErrorsPresent,
};
